<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-content">
      <el-table :data="recordLists" border>
        <el-table-column prop="sub_name" label="学生姓名" />
        <el-table-column prop="editor_name" label="申请方" />
        <el-table-column prop="shop_name" label="校区" />
        <el-table-column label="课包金额">
          <template slot-scope="scope">
            {{ scope.row.price/100 }}元
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" />
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  name: 'ActiveExchangeRecord',
  data() {
    return {
      listQuery: {
        total: 0,
        p: 1,
        limit: 20
      },
      recordLists: []
    }
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.$http.getChangeFlowList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.recordLists = res.data.list
      })
    }
  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
